import React from 'react';

// Gray pulsing placeholder shown while async (Redmine) data loads.
// Uses Tailwind's animate-pulse; sizes via props so callers match the real content.
export default function Skeleton({ width = '100%', height = 14, radius = 6, className = '', style = {} }) {
  return (
    <span
      aria-hidden="true"
      className={`animate-pulse ${className}`}
      style={{ display: 'inline-block', background: '#ECEBE5', borderRadius: radius, width, height, ...style }}
    />
  );
}
